<template>
  <div class="text-center loader">
    <div style="position: relative; top: 40%; color:black !important">
      <div
        class="la-ball-scale-ripple-multiple la-2x icon-wrapper">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loading2',
};
</script>

<style lang="scss" src="./loading2.scss" scoped></style>
